window.seconds2time = (seconds, timeformat) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  seconds = Math.floor(seconds - hours * 3600 - minutes * 60);
  let time = '';
  const arr = [];

  if (hours > 0) {
    time = `${hours} <small><em>h</em></small> `;
    arr.push(('0' + hours).slice(-2));
  }

  if (minutes > 0) {
    time += `${minutes} <small><em>min</em></small> `;
    arr.push(('0' + minutes).slice(-2));
  } else {
    arr.push('00');
  }

  if (seconds > 0) {
    time += `${seconds} <small><em>s</em></small> `;
    arr.push(('0' + seconds).slice(-2));
  } else {
    arr.push('00');
  }

  return timeformat ? arr.join(':') : time;
};

window.flash = message => {
  window.VueEventHub.$emit('flash', message);
};

window.error = message => {
  window.VueEventHub.$emit('error', message);
};

window.showHide = (targetId, show) => {
  const element = document.getElementById(targetId);
  element.classList[show ? 'remove' : 'add']('is-hidden');
};

window.urlFromObject = (properties, default_url = null) => {
  const parameters = {};
  Object.keys(properties).forEach(key => {
    const value = properties[key];
    if (typeof value === 'boolean' && value) {
      parameters[key] = value;
    } else if (typeof value === 'object' && value !== null && value.length) {
      const obj = value;
      parameters[key] = [];

      Object.keys(obj).forEach(k => {
        parameters[key].push(key + '[]=' + obj[k].id);
      });
    } else if (typeof value === 'number' || typeof value === 'string' || value === null) {
      parameters[key] = value;
    }
  });

  const arr = [];
  Object.keys(parameters).forEach(key => {
    const value = parameters[key];
    if (typeof value === 'object' && value !== null) {
      arr.push(value.join('&'));
    } else {
      arr.push(key + '=' + (value === null ? '' : value));
    }
  });
  if (default_url) {
    return default_url + '?' + arr.join('&');
  } else {
    return window.location.href.split('?')[0] + '?' + arr.join('&');
  }
};

window.reloadOnHistoryBack = function () {
  const parameter = 'r';
  const url = location.href.split('?');
  let props = url.length === 2 ? url[1].split('&') : [];
  const reload = props.filter(prop => prop.split('=')[0] === parameter)[0];
  if (reload && typeof reload !== 'undefined') {
    props = props.filter(prop => prop !== parameter);
    location.href = location.href.split('?')[0] + '?' + props.join('&');
  } else {
    props.push(parameter);
    history.replaceState({ page: 1 }, 'Reload', '?' + props.join('&'));
  }
};

window.formatTime = (sec_num) => {
  let hours   = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {
    hours   = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return hours + ':' + minutes + ':' + seconds;
};
